import i18next from "i18next";
import { Modal } from "react-bootstrap";
import { OpportunityAttachment } from "src/api/models/AccountEntity";

type Props = {
  isOpen?: boolean;
  closePreview: () => void;
  attachment?: OpportunityAttachment & {
    url: string;
  }
};

export default function OpportunityFilePreviewModal({ isOpen, closePreview, attachment }: Props) {
  if (!attachment) return null;

  const url = 'https://mozilla.github.io/pdf.js/legacy/web/viewer.html?file=' + encodeURIComponent(attachment.url);

  return (
    <Modal show={isOpen} size="xl">
      <Modal.Header closeButton onClick={closePreview}>
        <Modal.Title>{attachment.Title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <object
          style={{ height: '80vh', width: '100%' }}
          data={url}
          type="application/pdf">
          <p>{i18next.t('file_preview_error')}</p>
        </object>
      </Modal.Body>
    </Modal>
  )
}
